import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Button from "components/semantic/Button";
import Card from "components/common/Card";
import { ScanningStatus } from "./ScaningStatus";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { clearData } from "store/slice/kyp.slice";
import { ALL_POLICY_TYPES } from "utils/utils";

export const DocumentScanner: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const policyDetails = useAppSelector((state) => state.rootReducer.kypSlice.successKYPResult);
  const [step, setStep] = useState(0);

  const [wentToManual, setWentToManual] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setWentToManual(true);
    }, 120000);
  }, []);

  const params = useParams();

  const navigationHandler = () => {
    dispatch(clearData());
    if (wentToManual && !policyDetails) {
      navigate("/kyp/policies", { replace: true });
      return;
    }

    if (policyDetails?.policyTypeId === ALL_POLICY_TYPES.HEALTH) navigate(`/kyp/policy-preview/${params?.policyId}`, { replace: true });
    else if (policyDetails?.policyTypeId === ALL_POLICY_TYPES.MOTOR) navigate(`/kyp/motor-preview/${params?.policyId}`, { replace: true });
    else navigate(`/kyp/life-preview/${params?.policyId}`, { replace: true });
  };

  return (
    <div className="flex items-center justify-center px-0 md:px-4">
      <div className="w-full ">
        <Card className="hidden md:grid w-full ">
          <div className="flex justify-center xl:mx-10 xl:mt-8 m-5 mb-0 ">
            <ScanningStatus isScanned={policyDetails} step={step} setStep={setStep} isManual={wentToManual} />
          </div>
          <div className="px-4 py-2 flex justify-center">
            <div className="flex justify-center items-center py-6 w-[37rem] p-5 ">
              <div className="relative w-full aspect-video overflow-hidden rounded-lg border border-gray-300 shadow-all-side">
                <ReactPlayer url="https://www.youtube.com/watch?v=iVwPRBEEaGM" controls playing muted loop width="100%" height="100%" className="react-player" />
              </div>
            </div>
          </div>

          <hr />
          <div className={`flex justify-center p-5 `}>
            <Button disabled={!((policyDetails && step === 4) || wentToManual)} title={wentToManual && !policyDetails ? "GO TO HOME" : "NEXT"} type="submit" onClick={navigationHandler} className={`${(policyDetails && step === 4) || wentToManual ? "" : "opacity-50 pointer-events-none"}`} />
          </div>
        </Card>
        <div className="flex flex-col md:hidden gap-3">
          <Card className="md:hidden w-full rounded-lg" parentClassName={`border-2 border-gray-300 shadow-none `}>
            <ScanningStatus isScanned={policyDetails} step={step} setStep={setStep} isManual={wentToManual} />
          </Card>

          <Card className="md:hidden w-full rounded-lg" parentClassName={`border-2 border-gray-300 shadow-none `}>
            <div className="relative w-full max-w-[1000px] aspect-video overflow-hidden rounded-lg ">
              {/* Video Player */}
              <ReactPlayer url="https://www.youtube.com/watch?v=iVwPRBEEaGM" controls playing muted loop width="100%" height="100%" className="react-player" />
            </div>
          </Card>

          <Card className={`w-full rounded-lg bg-white flex md:hidden justify-center py-4 `} parentClassName={`border-2 border-gray-300 shadow-none`}>
            <Button disabled={!((policyDetails && step === 4) || wentToManual)} title={wentToManual && !policyDetails ? "GO TO HOME" : "NEXT"} type="submit" onClick={navigationHandler} className={`${(policyDetails && step === 4) || wentToManual ? "" : "opacity-50 pointer-events-none"}`} />
          </Card>
        </div>
      </div>
    </div>
  );
};
